var _path, _path2, _path3, _g, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTradeAnalyzerFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8801 14.0938H1.5791C1.1651 14.0938 0.829102 13.7578 0.829102 13.3438C0.829102 12.9297 1.1651 12.5938 1.5791 12.5938H7.8801C8.2941 12.5938 8.6301 12.9297 8.6301 13.3438C8.6301 13.7578 8.2941 14.0938 7.8801 14.0938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9904 4.39844H10.6904C10.2764 4.39844 9.94043 4.06244 9.94043 3.64844C9.94043 3.23444 10.2764 2.89844 10.6904 2.89844H16.9904C17.4044 2.89844 17.7404 3.23444 17.7404 3.64844C17.7404 4.06244 17.4044 4.39844 16.9904 4.39844Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_23931_33318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 8,
    height: 7
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.799805 0.5H7.0256V6.6916H0.799805V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_23931_33318)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9128 2C3.0238 2 2.2998 2.716 2.2998 3.597C2.2998 4.477 3.0238 5.192 3.9128 5.192C4.8028 5.192 5.5258 4.477 5.5258 3.597C5.5258 2.716 4.8028 2 3.9128 2ZM3.9128 6.692C2.1968 6.692 0.799805 5.304 0.799805 3.597C0.799805 1.89 2.1968 0.5 3.9128 0.5C5.6298 0.5 7.0258 1.89 7.0258 3.597C7.0258 5.304 5.6298 6.692 3.9128 6.692Z",
    fill: "white"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1872 11.7109C14.2972 11.7109 13.5732 12.4269 13.5732 13.3069C13.5732 14.1879 14.2972 14.9029 15.1872 14.9029C16.0762 14.9029 16.7992 14.1879 16.7992 13.3069C16.7992 12.4269 16.0762 11.7109 15.1872 11.7109ZM15.1872 16.4029C13.4702 16.4029 12.0732 15.0139 12.0732 13.3069C12.0732 11.5999 13.4702 10.2109 15.1872 10.2109C16.9032 10.2109 18.2992 11.5999 18.2992 13.3069C18.2992 15.0139 16.9032 16.4029 15.1872 16.4029Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTradeAnalyzerFilter);
export default __webpack_public_path__ + "static/media/trade-analyzer-filter.96eab96cb3d95ff521118016bda38fbc.svg";
export { ForwardRef as ReactComponent };